import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import cmsPageAPI from "../../api/cmsPageApi";
import SEO from "../../components/SEO";
import Breadcrump from "../../components/Breadcrump";
import { motion } from "framer-motion";
import homePageAPI from "../../api/homePageApi";
import homePagePayload from "../../config/homePayload";
import Product from "../products/Card";


function AboutUs() {
  const location = useLocation();
  const path = location.pathname.split("/")[1];

  const [metaData, setMetaData] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
    const [products, setProducts] = useState([]);


  useEffect(() => {
    fetchAboutDetails();
  }, [path]);

  
  const fetchAboutDetails = async () => {
    try {
      const res = await cmsPageAPI.details(path);

      if (res.code === 200) {
        const result = res.data;

        console.log(result.meta);

        setTitle(result.title);
        setDescription(result.content);
        setMetaData(result?.meta);
      }
    } catch (err) { }
  };
 const fetchHomePageDetails = async () => {
    const res = await homePageAPI.homePage(homePagePayload);

    if (res.code === 200) {
      const result = res.data;

      setProducts(result?.products);
    }
  };
  
  return (
    <>
      <SEO meta={metaData} />

      <Breadcrump title={title} />

      {/* <section className="s-term-user flat-spacing-25">
        <div className="container">
          <div className="content text-dark">
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </div>
      </section> */}





      <section className="hero-sanctuary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="display-title mb-4">
               प्रकृति से जुड़ा, <br />
                <span>आपके लिए बनाया गया।🌿</span>
              </h1>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <div dangerouslySetInnerHTML={{ __html: description }} />
              
              </motion.div>
            </div>
            <div className="col-lg-5 offset-lg-1">
              <motion.div
                className="arch-window"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.2 }}
              >
                <img src={`${process.env.PUBLIC_URL}images/About.png`} alt="Ritual" className="arch-img" />
              </motion.div>
            </div>
              {/* <button className="btn btn-outline-dark rounded-0 px-4 py-2 text-uppercase small letter-spacing-2">
                  Explore the Collection
                </button> */}
                {products && products.length > 0 && (
        <div className="compact-section">
          <div className="container ">
            <div className="">
              {/* <div className="">
                <h4>Our Products</h4>
                  <h2 className="compact-title">Essential <span>Care</span></h2>
              </div> */}
              <div className="text-center mb-5">
                {/* <span className="compact-sub">Daily Rituals</span> */}
                <h2 className="compact-title text-start">
                  Feature <span>Products</span>
                </h2>
              </div>
              <div className="row  g-4 justify-content-center">
                {products.map((product, index) => (
                  <div
                    className="col-lg-3 col-sm-6 col-xs-6 mb-3"
                    key={[product._id || index]}
                  >
                    <Product item={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
          </div>
        </div>
      </section>

    </>
  );
}

export default AboutUs;